import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: #f5f5f5;
  text-align: center;
`;

export const ErrorTitle = styled.h1`
  font-size: 2rem;
  color: #e74c3c;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const ErrorMessage = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
  max-width: 600px;
  line-height: 1.6;
`;

export const ErrorDetails = styled.details`
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 2rem;
  max-width: 800px;
  width: 100%;
  text-align: left;
`;

export const ErrorSummary = styled.summary`
  font-weight: 600;
  color: #333;
  cursor: pointer;
  margin-bottom: 1rem;
`;

export const ErrorStack = styled.pre`
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 1rem;
  font-size: 0.9rem;
  color: #495057;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const RetryButton = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #0056b3;
  }

  &:active {
    transform: translateY(1px);
  }
`;
